import { handleRequest } from "../utilities/requestHandler";

export const getAllUsers = () =>
    handleRequest("get", "/users");

export const getMachinesByProvision = () =>
    handleRequest("get", "/machines/by-provision");